import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';

import { createRESTContract } from '../../index';
import {
  DataSourceDataSchema,
  DataSourceDetailsSchema,
  MoveDataSourceSchema,
  TrainDataSourceSchema,
  TrainingFreshnessSchema,
  UpdateDataSourceSchema,
  UpdateExistingDataSourceFileSchema,
} from './data-sources.schema';

const { DATA_SOURCE } = PERMISSIONS;

export const dataSourcesContract = createRESTContract({
  uploadDataSource: {
    // This is used by frontend to upload one file per time.
    // For bulk upload, we are using sockets.
    method: 'POST',
    path: '/ai-knowledge-hub',
    permissions: [DATA_SOURCE.DATA_SOURCE_UPLOAD],
    body: DataSourceDataSchema,
    response: z.array(DataSourceDetailsSchema),
  },
  getAllDataSources: {
    method: 'GET',
    path: '/ai-knowledge-hub',
    permissions: [DATA_SOURCE.DATA_SOURCE_LIST],
    response: z.array(DataSourceDetailsSchema),
  },
  getDataSource: {
    method: 'GET',
    path: '/ai-knowledge-hub/:id',
    permissions: [DATA_SOURCE.DATA_SOURCE_DOWNLOAD],
    response: z.string(),
  },
  deleteDataSource: {
    method: 'DELETE',
    path: '/ai-knowledge-hub/:id',
    permissions: [DATA_SOURCE.DATA_SOURCE_DELETE],
    body: z.undefined(),
    response: z.void(),
  },
  updateDataSourceDetails: {
    method: 'PUT',
    path: '/ai-knowledge-hub',
    permissions: [DATA_SOURCE.DATA_SOURCE_EDIT],
    body: UpdateDataSourceSchema,
    response: z.array(DataSourceDetailsSchema),
  },
  vectorTrainSource: {
    method: 'POST',
    path: '/ai-knowledge-hub/train',
    permissions: [DATA_SOURCE.DATA_SOURCE_MANUAL_TRAINING],
    body: TrainDataSourceSchema,
    response: z.array(DataSourceDetailsSchema),
  },
  updateExistingDataSourceFile: {
    method: 'POST',
    path: '/ai-knowledge-hub/update-existing-file',
    permissions: [DATA_SOURCE.DATA_SOURCE_MANUAL_TRAINING],
    body: UpdateExistingDataSourceFileSchema,
    response: z.void(),
  },
  moveDataSource: {
    method: 'POST',
    path: '/ai-knowledge-hub/:id/move',
    permissions: [DATA_SOURCE.DATA_SOURCE_MOVE_FILE],
    body: MoveDataSourceSchema,
    response: z.array(DataSourceDetailsSchema),
  },
  getTrainingFreshness: {
    method: 'GET',
    path: '/ai-knowledge-hub/training-freshness',
    permissions: [DATA_SOURCE.DATA_SOURCE_LIST],
    response: TrainingFreshnessSchema,
  },
});
